import request from "../request";
import base from "@/api/base";
import { encryptLoginPayload } from "@/Utils/loginEncryption";

export default {
  // 移除直接创建的 request 实例，改为动态生成
  getRequest() {
    // 每次请求前都获取最新的 baseUrl
    return new request(`${base.getUsrBaseUrl()}/web/user`);
  },

  getCaptcha() {
    return this.getRequest().get("/captcha");
  },

  async login(payload) {
    const loginRequest = this.getRequest();
    const keyResponse = await loginRequest.get("/login-key");
    if (keyResponse.error) {
      return keyResponse;
    }
    try {
      const encryptedPayload = await encryptLoginPayload(keyResponse.data, payload);
      return loginRequest.post("/login", encryptedPayload);
    } catch (error) {
      return { error: error.message || "登录信息加密失败", status: 0 };
    }
  },

  getCurrentUser() {
    return this.getRequest().get("/me");
  },

  logout() {
    return this.getRequest().delete("/logout");
  },

  getVersion(params = {}) {
    return this.getRequest().get("/version", params);
  },
};
